var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOffOutline = function SvgEyeOffOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3 3 3.59 3.59M21 21l-3.589-3.589m-3.536 1.414q-.912.174-1.874.175c-4.478 0-8.268-2.943-9.542-7a10 10 0 0 1 1.563-3.029m5.857.908a3 3 0 1 1 4.243 4.243M9.879 9.878l4.243 4.242M9.879 9.88l-3.29-3.29m7.533 7.532L6.589 6.59m7.533 7.532 3.29 3.29M6.588 6.59A9.95 9.95 0 0 1 12.001 5c4.477 0 8.268 2.943 9.542 7a10.02 10.02 0 0 1-4.132 5.411"
  })));
};
export default SvgEyeOffOutline;